{
  "loves": [
    "Golden Pumpkin",
    "Magic Rock Candy",
    "Pearl",
    "Prismatic Shard",
    "Rabbit's Foot",
    "Stardrop Tea"
  ],
  "likes": [
    "All Artisan Goods (except Oil and Void Mayonnaise)",
    "All Cooking (except Bread, Fried Egg, Seafoam Pudding, Strange Bun)",
    "All Flowers (except Poppy)",
    "All Foraged Minerals (except Quartz)",
    "All Fruit Tree Fruits (except Banana & Mango)",
    "All Gems (except Prismatic Shard)",
    "All Vegetables (except Hops, Tea Leaves, Unmilled Rice, Wheat)",
    "Life Elixir",
    "Maple Syrup",
    "Piña Colada",
    "Rainbow Shell",
    "Treasure Chest"
  ],
  "neutrals": [
    "All Books (except Price Catalogue)",
    "Bread",
    "Coral",
    "Duck Feather",
    "Fried Egg",
    "Hops",
    "Mystic Syrup",
    "Nautilus Shell",
    "Roe",
    "Squid Ink",
    "Sweet Gem Berry",
    "Tea Leaves",
    "Truffle",
    "Wheat",
    "Wool"
  ],
  "dislikes": [
    "All Artifacts",
    "All Bombs",
    "All Building Materials",
    "All Crafted Floors & Paths",
    "All Fences",
    "All Fertilizer",
    "All Fish (except Carp & Snail)",
    "All Geode Minerals",
    "All Geodes",
    "All Seeds",
    "All Sprinklers",
    "All Tackle",
    "All Trinkets",
    "Cave Carrot",
    "Driftwood",
    "Field Snack",
    "Fireworks",
    "Jack-O-Lantern",
    "Oak Resin",
    "Oil",
    "Pine Tar",
    "Price Catalogue",
    "Qi Fruit",
    "Solar Essence",
    "Spring Onion",
    "Tea Set",
    "Unmilled Rice",
    "Vinegar",
    "Void Egg",
    "Void Essence",
    "Wheat Flour"
  ],
  "hates": [
    "All Bait",
    "All Fossils",
    "All Monster Loot",
    "All Trash",
    "Carp",
    "Copper Ore",
    "Dragon Tooth",
    "Green Algae",
    "Hay",
    "Iron Ore",
    "Monster Musk",
    "Poppy",
    "Radioactive Bar",
    "Radioactive Ore",
    "Red Mushroom",
    "Sap",
    "Sea Urchin",
    "Seafoam Pudding",
    "Seaweed",
    "Snail",
    "Strange Bun",
    "Sugar",
    "Void Mayonnaise",
    "White Algae"
  ]
}
